module.exports = __webpack_public_path__ + "img/11.8.TSS.ea520018.png";